import styled from 'styled-components';

export const DateContainer = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  background: #f6f6f6;
  border-radius: 6px;
  padding: 2px 0;
`;
export const Range = styled.div`
  margin-top: 50px;
  position: absolute;
`;

export const DateRange = styled.div`
  display: flex;
  flex-direction: column;
  background: #f6f6f6;
  border: 1px solid #dadada;
  box-sizing: border-box;
  border-radius: 6px;
  align-items: center;
  position: relative;
  height: 2rem;
`;

export const ModalMask = styled.div`
  position: fixed;
  inset: 0;
  margin: 0;
  opacity: var(--modal-light-opacity, 0.1);
  z-index: 70;
  background-color: var(--model-background, #000);

  & + div {
    z-index: 71;
  }
`;

export const DateBorder = styled.div`
  height: 100%;
  border: 1px solid #dadada;
`;

export const DateText = styled.div`
  font-weight: ${({ selected }: { selected: any }) => (selected ? '600' : 'normal')};
  font-size: 12px;
  line-height: 16px;
  padding: 10px;
  cursor: pointer;
  background-color: ${({ selected }: { selected: any }) => (selected ? '#E9F3FD' : '#fff')};
  color: ${({ selected }: { selected: any }) => (selected ? '#1890ff' : 'black')};
  height: 100%;
  align-items: center;
  display: flex;

  &:hover {
    background: #e9f3fd;
    color: #1890ff;
  }
`;

export const DisabledDate = styled.div`
  opacity: 0.45;
  pointer-events: none;
  font-size: 12px;
  line-height: 16px;
  padding: 0 5px;
  cursor: pointer;
  height: 100%;
  align-items: center;
  display: flex;
`;
